import { render, staticRenderFns } from "./AppProjectSkelleton.vue?vue&type=template&id=4219583b&"
import script from "./AppProjectSkelleton.vue?vue&type=script&lang=js&"
export * from "./AppProjectSkelleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports